import { render } from "./About.vue?vue&type=template&id=0c1e2f26"
const script = {}

import exportComponent from "C:\\wamp64\\www\\websites\\vueproject\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__